// Canonical access rule for the Cash Refunds queue.
//
// Same shape as stripe_connect/access.ts: the sidebar link and the route guard
// both read this, so the nav can never show a page the routes would bounce.
//
// Grant "Cash Refunds → Access" (CASH_REFUNDS_ACCESS) to a role in the Role
// editor to expose the page. Ronin admins (role_id 1) always have it.
//
// NOTE: this governs who reaches the PAGE. Canceling a refund is additionally
// gated on the JWT's x-hasura-default-role === "admin", because that is what
// ronin-api enforces on /api/cashRefund/cancel. Do not widen one without the
// other, or the UI will offer a button the API refuses.

export const cashRefundAccessFor = (user: any) => {
  const granted: any[] = user?.role?.permissions?.cash_refunds ?? [];
  const isAdmin = user?.role_id === 1;

  return {
    access:
      isAdmin ||
      granted.some(
        (entry) =>
          typeof entry?.value === "string" && entry.value === "CASH_REFUNDS_ACCESS"
      ),
  };
};
